// This file is auto-generated by @hey-api/openapi-ts

export const StrikeZoneSchema = {
  type: "object",
  required: ["name", "bottomInches", "topInches", "sideFromCenterInches"],
  properties: {
    name: {
      type: "string",
    },
    bottomInches: {
      type: "number",
    },
    topInches: {
      type: "number",
    },
    sideFromCenterInches: {
      type: "number",
    },
    strikeZoneYInches: {
      type: "number",
    },
    topIncludedExpansionInches: {
      type: "number",
      default: 0,
    },
    bottomIncludedExpansionInches: {
      type: "number",
      default: 0,
    },
    sideFromCenterIncludedExpansionInches: {
      type: "number",
      default: 0,
    },
    ageGroup: {
      nullable: true,
      allOf: [
        {
          $ref: "#/components/schemas/AgeGroup",
        },
      ],
    },
  },
  description: `Additional validation: topInches must be greater than bottomInches. The *Included* fields are assumed to be pre-added to the top/bottom/side. By having this content, we are backwards compatible and can get all required content for various operations. They are 0 by default to ensure backwards compatibility.
`,
} as const;

export const StrikeZonePresetSchema = {
  type: "object",
  required: [
    "name",
    "bottomInches",
    "topInches",
    "sideFromCenterInches",
    "strikeZoneYInches",
  ],
  properties: {
    name: {
      type: "string",
    },
    bottomInches: {
      type: "number",
    },
    topInches: {
      type: "number",
    },
    sideFromCenterInches: {
      type: "number",
    },
    strikeZoneYInches: {
      type: "number",
    },
  },
  description: `A single strike-zone preset returned by /balltracker/strike-zone/{sport}. Uses camelCase property names as served by the balltracker API.
`,
} as const;

export const StrikeZonePresetsResponseSchema = {
  type: "object",
  additionalProperties: {
    $ref: "#/components/schemas/StrikeZonePreset",
  },
  description: `Map of age-group label (e.g. "8U", "9U", "College", "Pro") to its StrikeZonePreset for the requested sport.
`,
} as const;

export const ActivityWindowSchema = {
  type: "object",
  required: ["startTime", "endTime"],
  properties: {
    id: {
      type: "string",
    },
    startTime: {
      type: "integer",
    },
    endTime: {
      type: "integer",
      nullable: true,
    },
  },
} as const;

export const SmartPassParamsSchema = {
  type: "object",
  properties: {
    startTime: {
      type: "string",
      format: "date-time",
      description:
        "Start time of the feature, defaults to now if no content passed in",
    },
    endTime: {
      type: "string",
      format: "date-time",
      description:
        "Explicit end time, if omitted the durationSeconds and startTime are used",
    },
    durationSeconds: {
      type: "integer",
      default: 7500,
    },
    extend: {
      type: "boolean",
      default: false,
      description:
        "Extends a pass by durationSeconds if an existing permission exists",
    },
    extra: {
      type: "object",
      additionalProperties: true,
      description: "Additional metadata to store with the pass",
    },
  },
} as const;

export const ActionSucceededSchema = {
  type: "object",
  properties: {
    body: {
      oneOf: [
        {
          type: "string",
        },
        {
          type: "object",
        },
      ],
    },
  },
} as const;

export const ActionFailedSchema = {
  type: "object",
  properties: {
    error: {
      oneOf: [
        {
          type: "string",
        },
        {
          type: "object",
        },
      ],
    },
  },
} as const;

export const ActionResponseSchema = {
  oneOf: [
    {
      $ref: "#/components/schemas/ActionSucceeded",
    },
    {
      $ref: "#/components/schemas/ActionFailed",
    },
  ],
} as const;

export const ChallengeRequestParamsSchema = {
  type: "object",
  required: ["event_uuid", "machine_uuid", "event_time"],
  properties: {
    event_uuid: {
      type: "string",
      description: "The UUID of the event being challenged",
    },
    machine_uuid: {
      type: "string",
      description: "The UUID of the machine",
    },
    event_time: {
      type: "number",
      format: "float",
      description: "The time of the event in seconds since epoch",
    },
    pitch_data: {
      type: "object",
      nullable: true,
      description: "Optional pitch data for the challenge",
    },
    hit_data: {
      type: "object",
      nullable: true,
      description: "Optional hit data for the challenge",
    },
    tag_data: {
      type: "object",
      nullable: true,
      description: "Optional tag data for the challenge",
    },
    aero_data: {
      type: "object",
      nullable: true,
      description: "Optional aerodynamic data for the challenge",
    },
    strike_zone_data: {
      type: "object",
      nullable: true,
      description: "Optional strike zone data for the challenge",
    },
    ball: {
      type: "string",
      nullable: true,
      description: "Optional ball identifier",
    },
    contributing_events: {
      type: "array",
      nullable: true,
      items: {
        type: "string",
      },
      description: "Optional list of UUIDs of contributing events",
    },
    server_time_now: {
      type: "number",
      format: "float",
      nullable: true,
      description: "Optional server time in seconds since epoch",
    },
    no_lookup: {
      type: "boolean",
      default: false,
      description: "If true, skip lookup operations",
    },
  },
} as const;

export const ErrorResponseSchema = {
  type: "object",
  properties: {
    error: {
      type: "string",
    },
  },
} as const;

export const AgeGroupSchema = {
  type: "string",
  enum: [
    "8U",
    "9U",
    "10U",
    "11U",
    "12U",
    "13U",
    "14U",
    "15U",
    "16U",
    "17U",
    "18U",
    "College",
    "Pro",
  ],
} as const;

export const FieldConfigSchema = {
  type: "object",
  required: [
    "name",
    "infieldAtFoulLineFeet",
    "fenceFirstBaseFeet",
    "fenceThirdBaseFeet",
    "fenceLeftFieldFeet",
    "fenceCenterFieldFeet",
    "fenceRightFieldFeet",
    "diamondSizeFeet",
  ],
  properties: {
    name: {
      type: "string",
    },
    infieldAtFoulLineFeet: {
      type: "number",
    },
    fenceFirstBaseFeet: {
      type: "number",
    },
    fenceThirdBaseFeet: {
      type: "number",
    },
    fenceLeftFieldFeet: {
      type: "number",
    },
    fenceCenterFieldFeet: {
      type: "number",
    },
    fenceRightFieldFeet: {
      type: "number",
    },
    diamondSizeFeet: {
      type: "number",
      format: "double",
    },
    ageGroup: {
      allOf: [
        {
          $ref: "#/components/schemas/AgeGroup",
        },
      ],
      default: "College",
    },
  },
} as const;

export const ParkConfigSchema = {
  type: "object",
  properties: {
    sport: {
      allOf: [
        {
          $ref: "#/components/schemas/SportType",
        },
      ],
      nullable: true,
    },
    strikeZone: {
      allOf: [
        {
          $ref: "#/components/schemas/StrikeZone",
        },
      ],
      nullable: true,
    },
    field: {
      allOf: [
        {
          $ref: "#/components/schemas/FieldConfig",
        },
      ],
      nullable: true,
    },
    rubberDistanceF: {
      allOf: [
        {
          type: "number",
        },
      ],
      nullable: true,
    },
  },
} as const;

export const UnifiedConfigSchema = {
  type: "object",
  properties: {
    apiVersion: {
      type: "string",
    },
    ball: {
      type: "string",
    },
    sport: {
      type: "string",
      enum: ["baseball", "softball"],
    },
    rubberDistanceF: {
      type: "number",
      nullable: true,
    },
    defaultExtensionF: {
      type: "number",
      nullable: true,
    },
    machine: {
      allOf: [
        {
          $ref: "#/components/schemas/MachinePublicHydrated",
        },
      ],
      nullable: true,
    },
    strikeZone: {
      allOf: [
        {
          $ref: "#/components/schemas/StrikeZone",
        },
      ],
      nullable: true,
    },
    field: {
      allOf: [
        {
          $ref: "#/components/schemas/FieldConfig",
        },
      ],
      nullable: true,
    },
    watching: {
      type: "boolean",
    },
  },
} as const;

export const UnifiedConnectorResponseSchema = {
  type: "object",
  properties: {
    body: {
      oneOf: [
        {
          type: "string",
        },
        {
          $ref: "#/components/schemas/UnifiedConfig",
        },
      ],
    },
    code: {
      type: "integer",
    },
    mimetype: {
      type: "string",
    },
  },
} as const;

export const VersionPublicSchema = {
  type: "object",
  required: ["version", "codename"],
  properties: {
    version: {
      type: "string",
    },
    codename: {
      type: "string",
    },
  },
} as const;

export const MessageSchema = {
  type: "object",
  required: ["detail"],
  properties: {
    detail: {
      type: "string",
    },
  },
} as const;

export const UserDeleteMessageSchema = {
  type: "object",
  required: ["detail", "loginDeleted"],
  properties: {
    detail: {
      type: "string",
    },
    loginDeleted: {
      type: "boolean",
    },
  },
} as const;

export const B2CUserUpdateBodySchema = {
  type: "object",
  properties: {
    givenName: {
      type: "string",
    },
    familyName: {
      type: "string",
    },
  },
} as const;

export const CouponBodySchema = {
  type: "object",
  required: ["coupon"],
  properties: {
    coupon: {
      type: "string",
    },
  },
} as const;

export const LiveDataPassMachineSchema = {
  type: "object",
  required: ["machineUuid", "userId", "date"],
  properties: {
    machineUuid: {
      type: "string",
      format: "UUID",
    },
    userId: {
      type: "string",
    },
    date: {
      type: "string",
      format: "yyyy-mm-dd",
      example: "2024-07-24",
    },
  },
} as const;

export const LiveDataPassAuraSchema = {
  type: "object",
  required: ["userId", "date"],
  properties: {
    userId: {
      type: "string",
    },
    date: {
      type: "string",
      format: "yyyy-mm-dd",
      example: "2024-07-24",
    },
  },
} as const;

export const LiveDataPassGroupSchema = {
  type: "object",
  required: ["groupId", "userId", "date"],
  properties: {
    groupId: {
      type: "string",
    },
    userId: {
      type: "string",
    },
    date: {
      type: "string",
      format: "yyyy-mm-dd",
      example: "2024-07-24",
    },
  },
} as const;

export const LiveDataPassDBSchema = {
  type: "object",
  required: ["tenant_id", "start_time", "end_time"],
  properties: {
    tenant_id: {
      type: "string",
    },
    machine_uuid: {
      type: "string",
    },
    group_id: {
      type: "string",
    },
    start_time: {
      type: "number",
      format: "epoch seconds",
    },
    end_time: {
      type: "number",
      format: "epoch seconds",
    },
  },
} as const;

export const FeaturePassDBSchema = {
  type: "object",
  required: ["tenant_id", "feature_type", "start_time", "end_time"],
  properties: {
    tenant_id: {
      type: "string",
    },
    feature_type: {
      type: "string",
    },
    feature_details: {
      type: "object",
    },
    start_time: {
      type: "number",
      format: "epoch seconds",
    },
    end_time: {
      type: "number",
      format: "epoch seconds",
    },
  },
} as const;

export const FeaturePassPublicUserSchema = {
  type: "object",
  required: ["featureType", "startTime", "endTime"],
  properties: {
    featureType: {
      type: "string",
    },
    featureDetails: {
      type: "object",
    },
    startTime: {
      type: "number",
      format: "epoch seconds",
    },
    endTime: {
      type: "number",
      format: "epoch seconds",
    },
  },
} as const;

export const DurationTypeSchema = {
  type: "string",
  enum: ["day", "5day", "9day", "week", "month", "year", "forever"],
} as const;

export const GameSchema = {
  type: "object",
  properties: {
    external_id: {
      type: "string",
      nullable: true,
      default: null,
    },
    gameUuid: {
      anyOf: [
        {
          format: "uuid4",
          type: "string",
        },
        {
          type: "string",
        },
      ],
      nullable: true,
      default: null,
    },
    displayName: {
      type: "string",
    },
    generated_display_name: {
      type: "string",
    },
    lineups: {
      $ref: "#/components/schemas/LineupPair",
    },
    machine_uuid: {
      anyOf: [
        {
          format: "uuid4",
          type: "string",
        },
        {
          type: "string",
        },
      ],
    },
    sport: {
      type: "string",
    },
    ageGroup: {
      nullable: true,
      allOf: [
        {
          $ref: "#/components/schemas/AgeGroup",
        },
      ],
    },
    type: {
      type: "string",
      enum: ["game", "bullpen", "batting_practice"],
      default: "game",
    },
    substitutions: {
      default: [],
      items: {
        $ref: "#/components/schemas/Substitution",
      },
      type: "array",
    },
    teams: {
      $ref: "#/components/schemas/TeamPair",
    },
    teamNames: {
      nullable: true,
      default: null,
      allOf: [
        {
          $ref: "#/components/schemas/TeamPair",
        },
      ],
    },
    teamColors: {
      nullable: true,
      default: null,
      allOf: [
        {
          $ref: "#/components/schemas/TeamColorPair",
        },
      ],
    },
    times: {
      items: {
        $ref: "#/components/schemas/GamePart",
      },
      type: "array",
    },
    year_month: {
      type: "string",
    },
  },
  required: [
    "machine_uuid",
    "year_month",
    "sport",
    "generated_display_name",
    "times",
    "teams",
    "lineups",
  ],
} as const;

export const GamePartSchema = {
  type: "object",
  properties: {
    startTime: {
      format: "date-time",
      type: "number",
    },
    endTime: {
      format: "date-time",
      type: "number",
      nullable: true,
      default: null,
    },
    fieldUuid: {
      format: "uuid4",
      type: "string",
    },
    machineUuid: {
      anyOf: [
        {
          format: "uuid4",
          type: "string",
        },
        {
          type: "string",
        },
      ],
    },
  },
  required: ["machineUuid", "startTime"],
} as const;

export const MachineRegionListPublicSchema = {
  type: "object",
  required: ["regions"],
  properties: {
    regions: {
      type: "array",
      items: {
        type: "string",
      },
    },
    continue: {
      type: "string",
    },
  },
} as const;

export const MachineExtraSchema = {
  type: "object",
  properties: {
    field_cover: {
      type: "string",
      nullable: true,
    },
    complex_cover: {
      type: "string",
      nullable: true,
    },
  },
} as const;

export const MachinePublicSchema = {
  type: "object",
  required: ["machineUuid", "name", "region"],
  properties: {
    machineUuid: {
      type: "string",
      format: "UUID",
    },
    region: {
      type: "string",
    },
    name: {
      type: "string",
    },
    distanceMiles: {
      type: "number",
    },
    status: {
      type: "string",
      enum: ["active", "inactive"],
      nullable: true,
    },
    groupIds: {
      type: "array",
      items: {
        type: "string",
      },
    },
    extra: {
      oneOf: [
        {
          $ref: "#/components/schemas/MachineExtra",
        },
      ],
      nullable: true,
    },
  },
} as const;

export const MachinePublicHydratedSchema = {
  type: "object",
  required: ["machineUuid", "name", "region", "complex"],
  properties: {
    machineUuid: {
      type: "string",
      format: "UUID",
    },
    region: {
      type: "string",
    },
    complex: {
      type: "string",
      nullable: true,
    },
    name: {
      type: "string",
    },
    distanceMiles: {
      type: "number",
    },
    status: {
      type: "string",
      enum: ["active", "inactive"],
      nullable: true,
    },
    groupIds: {
      type: "array",
      items: {
        type: "string",
      },
    },
    currentGame: {
      oneOf: [
        {
          $ref: "#/components/schemas/Game",
        },
      ],
      nullable: true,
    },
    recentTag: {
      type: "object",
      nullable: true,
    },
    smartAvailableActive: {
      type: "array",
      nullable: true,
      items: {
        $ref: "#/components/schemas/ActivityWindow",
      },
    },
    umpireAssistActive: {
      type: "array",
      nullable: true,
      items: {
        $ref: "#/components/schemas/ActivityWindow",
      },
    },
    smartBlockedActive: {
      type: "array",
      nullable: true,
      items: {
        $ref: "#/components/schemas/ActivityWindow",
      },
    },
    recentActivity: {
      type: "object",
      nullable: true,
    },
    latestPing: {
      type: "object",
      nullable: true,
      description: "Most recent payload received from the remote machine.",
      properties: {
        machine_uuid: {
          type: "string",
          format: "UUID",
        },
        data: {
          type: "object",
          properties: {
            hostname: {
              type: "string",
            },
            software_revision: {
              type: "object",
              properties: {
                profile: {
                  type: "string",
                },
                hash: {
                  type: "string",
                },
              },
            },
            status: {
              type: "object",
              properties: {
                now: {
                  type: "number",
                  description:
                    "Unix epoch seconds at which the remote produced this ping.",
                },
                watching: {
                  type: "boolean",
                  nullable: true,
                },
                display_service: {
                  type: "boolean",
                  nullable: true,
                },
              },
              required: ["now"],
            },
          },
          required: ["status"],
        },
        blobs: {
          type: "array",
          items: {
            type: "string",
          },
        },
      },
      required: ["data"],
    },
    extra: {
      oneOf: [
        {
          $ref: "#/components/schemas/MachineExtra",
        },
      ],
      nullable: true,
    },
  },
} as const;

export const MachineIngestSchema = {
  allOf: [
    {
      $ref: "#/components/schemas/MachinePublic",
    },
  ],
  type: "object",
  properties: {
    location: {
      type: "array",
      items: {
        type: "number",
      },
      minItems: 2,
      maxItems: 2,
    },
    hostname: {
      type: "string",
    },
    timezone: {
      type: "string",
    },
    extra: {
      type: "object",
      additionalProperties: true,
    },
  },
} as const;

export const MachineDBSchema = {
  type: "object",
  required: ["machineUuid", "name", "region"],
  properties: {
    machineUuid: {
      type: "string",
      format: "UUID",
    },
    region: {
      type: "string",
    },
    name: {
      type: "string",
    },
    status: {
      type: "string",
      enum: ["active", "inactive"],
      nullable: true,
    },
    groupIds: {
      type: "array",
      items: {
        type: "string",
      },
    },
    location: {
      type: "object",
      properties: {
        type: {
          type: "string",
          enum: ["Point"],
        },
        coordinates: {
          type: "array",
          items: {
            type: "number",
          },
          minItems: 2,
          maxItems: 2,
        },
      },
      required: ["coordinates", "type"],
    },
    hostname: {
      type: "string",
    },
    sport: {
      type: "string",
      enum: ["baseball", "softball"],
    },
    ip: {
      type: "string",
      format: "ipv4",
    },
    timezone: {
      type: "string",
    },
    extra: {
      type: "object",
      additionalProperties: true,
    },
  },
} as const;

export const MachineOwnerOrgResponseSchema = {
  type: "object",
  required: [
    "orgId",
    "orgName",
    "passId",
    "passStartTime",
    "passEndTime",
    "featureType",
  ],
  properties: {
    orgId: {
      type: "string",
      description: "Organization ID",
    },
    orgName: {
      type: "string",
      description: "Organization name",
    },
    passId: {
      type: "string",
      description: "Feature pass ID",
    },
    passStartTime: {
      type: "integer",
      description: "Unix timestamp when the pass starts",
    },
    passEndTime: {
      type: "integer",
      description: "Unix timestamp when the pass ends",
    },
    featureType: {
      type: "string",
      description:
        "Type of feature/pass (e.g., video-annotation, smart-available)",
    },
  },
} as const;

export const TeamDBSchema = {
  type: "object",
  required: ["hidden", "league", "sport"],
  properties: {
    id: {
      type: "string",
      format: "UUID",
    },
    hidden: {
      type: "boolean",
    },
    external_ids: {
      type: "array",
      items: {
        type: "string",
      },
    },
    known_names: {
      type: "array",
      items: {
        type: "string",
      },
    },
    sport: {
      type: "string",
      enum: ["baseball", "softball"],
    },
    league: {
      type: "string",
    },
    region: {
      type: "string",
    },
    visibility_groups: {
      type: "array",
      items: {
        type: "string",
      },
    },
    management_groups: {
      type: "array",
      items: {
        type: "string",
      },
    },
    unofficial_members: {
      type: "array",
      items: {
        $ref: "#/components/schemas/LineupEntry",
      },
    },
    last_modified: {
      type: "number",
      nullable: true,
    },
    extra: {
      type: "object",
      nullable: true,
    },
  },
} as const;

export const WebsocketUrlSchema = {
  type: "object",
  required: ["websocket"],
  properties: {
    websocket: {
      type: "string",
    },
  },
} as const;

export const CheckoutUrlSchema = {
  type: "object",
  required: ["detail", "url"],
  properties: {
    detail: {
      type: "string",
    },
    url: {
      type: "string",
    },
  },
} as const;

export const SavePaymentMethodRequestBodySchema = {
  type: "object",
  required: ["paymentMethodId"],
  properties: {
    paymentMethodId: {
      type: "string",
      minLength: 1,
      description: "The Stripe payment method ID to save",
    },
  },
} as const;

export const PaymentMethodResponseSchema = {
  type: "object",
  description:
    "Payment method details. Fields are optional; empty object returned if no payment method is set.",
  properties: {
    type: {
      type: "string",
      description: "Payment method type (card or us_bank_account)",
    },
    brand: {
      type: "string",
      nullable: true,
      description:
        "Card brand (e.g., visa, mastercard). Present for card payment methods.",
    },
    last4: {
      type: "string",
      nullable: true,
      description:
        "Last 4 digits. Present for both card and bank account payment methods.",
    },
    expMonth: {
      type: "integer",
      nullable: true,
      description: "Card expiration month. Present for card payment methods.",
    },
    expYear: {
      type: "integer",
      nullable: true,
      description: "Card expiration year. Present for card payment methods.",
    },
    bankName: {
      type: "string",
      nullable: true,
      description: "Bank name. Present for us_bank_account payment methods.",
    },
    accountHolderName: {
      type: "string",
      nullable: true,
      description:
        "Account holder name. Present for us_bank_account payment methods.",
    },
  },
} as const;

export const GetPaymentMethodResponseSchema = {
  type: "object",
  required: ["payment_method"],
  properties: {
    payment_method: {
      nullable: true,
      allOf: [
        {
          $ref: "#/components/schemas/PaymentMethodResponse",
        },
      ],
      description:
        "The default payment method for the organization, or null if none is set.",
    },
  },
} as const;

export const SetupIntentResponseSchema = {
  type: "object",
  required: ["clientSecret"],
  properties: {
    clientSecret: {
      type: "string",
      description:
        "The Stripe SetupIntent client secret, used by Stripe.js to confirm payment method on the client",
    },
  },
} as const;

export const SensorDataPublicSchema = {
  type: "object",
  required: ["event_uuid", "id", "machine_uuid"],
  properties: {
    machine_uuid: {
      type: "string",
      format: "UUID",
    },
    event_uuid: {
      type: "string",
      format: "UUID",
    },
    id: {
      type: "string",
    },
    pitch_data: {
      type: "object",
      additionalProperties: true,
    },
    hit_data: {
      type: "object",
      additionalProperties: true,
    },
  },
} as const;

export const SensorDataIngestSchema = {
  type: "object",
  required: ["year_month", "machine_uuid", "payload"],
  properties: {
    machine_uuid: {
      type: "string",
      format: "UUID",
    },
    year_month: {
      type: "string",
    },
    payload: {
      type: "object",
      required: ["event_uuid"],
      properties: {
        event_uuid: {
          type: "string",
          format: "UUID",
        },
        pitch_data: {
          type: "object",
          additionalProperties: true,
        },
        hit_data: {
          type: "object",
          additionalProperties: true,
        },
        aero_data: {
          type: "object",
          additionalProperties: true,
        },
        contributing_events: {
          type: "array",
          items: {
            type: "string",
          },
        },
        RawEvents: {
          type: "array",
          items: {
            type: "object",
            additionalProperties: true,
          },
        },
      },
    },
  },
} as const;

export const SensorDataDBSchema = {
  type: "object",
  required: [
    "event_uuid",
    "id",
    "year_month",
    "machine_uuid",
    "event_time",
    "update_time",
  ],
  properties: {
    machine_uuid: {
      type: "string",
      format: "UUID",
    },
    year_month: {
      type: "string",
    },
    event_uuid: {
      type: "string",
      format: "UUID",
    },
    id: {
      type: "string",
    },
    event_time: {
      type: "number",
    },
    update_time: {
      type: "number",
    },
    pitch_data: {
      type: "object",
      additionalProperties: true,
    },
    hit_data: {
      type: "object",
      additionalProperties: true,
    },
    aero_data: {
      type: "object",
      additionalProperties: true,
    },
    contributing_events: {
      type: "array",
      items: {
        type: "string",
      },
    },
    RawEvents: {
      type: "array",
      items: {
        type: "object",
        additionalProperties: true,
      },
    },
  },
} as const;

export const InningSchema = {
  type: "object",
  properties: {
    half: {
      enum: ["top", "bottom"],
      type: "string",
    },
    integer: {
      type: "integer",
    },
  },
  required: ["integer", "half"],
} as const;

export const HitterCountSchema = {
  type: "object",
  properties: {
    balls: {
      type: "integer",
    },
    strikes: {
      type: "integer",
    },
  },
  required: ["balls", "strikes"],
} as const;

export const GameStateSchema = {
  type: "object",
  additionalProperties: true,
  required: [
    "paOfInning",
    "pitchOfPa",
    "awayScore",
    "homeScore",
    "inning",
    "count",
    "outs",
  ],
  properties: {
    paOfInning: {
      type: "integer",
    },
    pitchOfPa: {
      type: "integer",
    },
    awayScore: {
      type: "integer",
    },
    homeScore: {
      type: "integer",
    },
    inning: {
      $ref: "#/components/schemas/Inning",
    },
    count: {
      $ref: "#/components/schemas/HitterCount",
    },
    outs: {
      type: "integer",
    },
    hitterHasChanged: {
      type: "boolean",
      default: false,
    },
    inningHasChanged: {
      type: "boolean",
      default: false,
    },
    currentPitcher: {
      $ref: "#/components/schemas/LineupEntry",
    },
    currentCatcher: {
      $ref: "#/components/schemas/LineupEntry",
    },
    currentHitter: {
      $ref: "#/components/schemas/LineupEntry",
    },
  },
} as const;

export const GameStateDeltaSchema = {
  type: "object",
  additionalProperties: true,
  properties: {
    outsRecorded: {
      type: "integer",
    },
    pitchResult: {
      enum: [
        "InPlay",
        "StrikeSwinging",
        "StrikeCalled",
        "BallCalled",
        "Foul",
        "FoulTip",
        "HitByPitch",
        "CatchersInt",
      ],
      type: "string",
    },
    playResult: {
      enum: [
        "Out",
        "Sacrifice",
        "Single",
        "Double",
        "Triple",
        "HomeRun",
        "Error",
        "FieldersChoice",
        "StrikeoutSwinging",
        "StrikeoutLooking",
        "Walk",
      ],
      type: "string",
      nullable: true,
    },
    runsScored: {
      type: "integer",
    },
  },
  required: ["pitchResult", "outsRecorded", "runsScored"],
} as const;

export const tag_data_fieldSchema = {
  type: "object",
  required: ["metadata", "gameState"],
  properties: {
    metadata: {
      $ref: "#/components/schemas/GameStateDelta",
    },
    gameState: {
      $ref: "#/components/schemas/GameState",
    },
  },
  additionalProperties: true,
} as const;

export const TagDataIngestSchema = {
  type: "object",
  required: ["payload"],
  properties: {
    payload: {
      type: "object",
      required: ["tag_data", "event_uuid", "event_time", "machine_uuid"],
      properties: {
        id: {
          type: "string",
        },
        machine_uuid: {
          type: "string",
          format: "UUID",
        },
        year_month: {
          type: "string",
        },
        tag_data: {
          $ref: "#/components/schemas/tag_data_field",
          additionalProperties: true,
        },
        event_uuid: {
          type: "string",
          format: "UUID",
        },
        event_time: {
          type: "number",
        },
        update_time: {
          type: "number",
        },
      },
    },
  },
} as const;

export const TagDataDBSchema = {
  type: "object",
  required: [
    "event_uuid",
    "id",
    "year_month",
    "machine_uuid",
    "game_uuid",
    "event_time",
    "update_time",
    "tag_data",
  ],
  properties: {
    machine_uuid: {
      type: "string",
      format: "UUID",
    },
    year_month: {
      type: "string",
    },
    event_uuid: {
      type: "string",
      format: "UUID",
    },
    game_uuid: {
      type: "string",
      format: "UUID",
    },
    id: {
      type: "string",
    },
    event_time: {
      type: "number",
    },
    update_time: {
      type: "number",
    },
    tag_data: {
      $ref: "#/components/schemas/tag_data_field",
      additionalProperties: true,
    },
  },
} as const;

export const MergedDataPublicSchema = {
  type: "object",
  required: [
    "event_uuid",
    "year_month",
    "machine_uuid",
    "event_time",
    "update_time",
    "tag_data",
    "pitch_data",
    "hit_data",
  ],
  properties: {
    machine_uuid: {
      type: "string",
      format: "UUID",
    },
    year_month: {
      type: "string",
    },
    event_uuid: {
      type: "string",
      format: "UUID",
    },
    id: {
      type: "string",
    },
    event_time: {
      type: "number",
    },
    update_time: {
      type: "number",
    },
    ball: {
      type: "string",
      nullable: true,
    },
    tag_data: {
      $ref: "#/components/schemas/tag_data_field",
      additionalProperties: true,
    },
    pitch_data: {
      type: "object",
      nullable: true,
      additionalProperties: true,
    },
    hit_data: {
      type: "object",
      nullable: true,
      additionalProperties: true,
    },
  },
} as const;

export const UserSchema = {
  type: "object",
  required: ["userId", "roles"],
  properties: {
    userId: {
      type: "string",
      format: "UUID",
    },
    roles: {
      type: "array",
      items: {
        type: "string",
      },
    },
    givenName: {
      type: "string",
      nullable: true,
    },
    familyName: {
      type: "string",
      nullable: true,
    },
    emails: {
      type: "array",
      items: {
        type: "string",
      },
    },
  },
} as const;

export const OrganizationUserSchema = {
  type: "object",
  required: ["userId", "orgRoles"],
  properties: {
    userId: {
      type: "string",
      format: "UUID",
    },
    roles: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Roles",
      },
    },
    orgRoles: {
      type: "array",
      items: {
        $ref: "#/components/schemas/OrgRoles",
      },
    },
    givenName: {
      type: "string",
      nullable: true,
    },
    familyName: {
      type: "string",
      nullable: true,
    },
    emails: {
      type: "array",
      items: {
        type: "string",
      },
    },
  },
} as const;

export const UserOrgSchema = {
  type: "object",
  required: ["orgId", "orgName", "orgRoles"],
  properties: {
    orgId: {
      type: "string",
    },
    orgName: {
      type: "string",
    },
    orgRoles: {
      type: "array",
      items: {
        $ref: "#/components/schemas/OrgRoles",
      },
    },
  },
} as const;

export const VisibilityGroupsPublicSchema = {
  type: "object",
  required: ["visibilityGroups", "continue"],
  properties: {
    visibilityGroups: {
      type: "array",
      items: {
        type: "string",
      },
    },
    continue: {
      type: "string",
    },
  },
} as const;

export const ReportUrlSchema = {
  type: "object",
  required: ["detail", "url"],
  properties: {
    detail: {
      type: "string",
    },
    reportUrl: {
      type: "string",
    },
  },
} as const;

export const ReportPublicSchema = {
  type: "object",
  required: [
    "player_id",
    "game_id",
    "event_id",
    "report_type",
    "blob_item",
    "upload_time",
    "visiblility_groups",
    "year_month",
  ],
  properties: {
    player_id: {
      type: "string",
    },
    player_name: {
      type: "string",
    },
    stadium_name: {
      type: "string",
    },
    matchup: {
      type: "string",
    },
    tournament_name: {
      type: "string",
    },
    game_id: {
      type: "string",
    },
    event_id: {
      type: "string",
    },
    event_name: {
      type: "string",
    },
    report_type: {
      type: "string",
    },
    blob_item: {
      type: "string",
    },
    upload_time: {
      type: "integer",
    },
    visiblility_groups: {
      type: "array",
      items: {
        type: "string",
      },
    },
    year_month: {
      type: "string",
    },
  },
} as const;

export const ReportFragmentPublicSchema = {
  type: "object",
  required: ["player_id", "player_name"],
  properties: {
    player_id: {
      type: "string",
    },
    player_name: {
      type: "string",
    },
  },
} as const;

export const ReportsPlayerListPublicSchema = {
  type: "object",
  required: ["reports", "continue"],
  properties: {
    reports: {
      type: "array",
      items: {
        $ref: "#/components/schemas/ReportFragmentPublic",
      },
    },
    continue: {
      type: "string",
    },
  },
} as const;

export const ReportsListPublicSchema = {
  type: "object",
  required: ["reports", "continue"],
  properties: {
    reports: {
      type: "array",
      items: {
        $ref: "#/components/schemas/ReportPublic",
      },
    },
    continue: {
      type: "string",
    },
  },
} as const;

export const AuditRecordSchema = {
  type: "object",
  required: ["userId", "actionTime", "verb", "route"],
  properties: {
    userId: {
      type: "string",
      format: "UUID",
    },
    actionTime: {
      type: "number",
    },
    ip: {
      type: "string",
    },
    body: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "object",
        },
      ],
    },
    params: {
      type: "object",
    },
    verb: {
      type: "string",
    },
    route: {
      type: "string",
    },
  },
} as const;

export const ErrorSchema = {
  type: "object",
  required: ["detail"],
  properties: {
    detail: {
      type: "string",
    },
  },
} as const;

export const PlayerPublicSchema = {
  type: "object",
  required: ["external_ids", "known_names"],
  properties: {
    external_ids: {
      type: "array",
      items: {
        type: "string",
      },
    },
    known_names: {
      type: "array",
      items: {
        type: "string",
      },
    },
    pitch_side: {
      type: "string",
    },
    hit_side: {
      type: "string",
    },
    league: {
      type: "string",
    },
  },
} as const;

export const PlayerDBSchema = {
  type: "object",
  required: [
    "hidden",
    "league",
    "sport",
    "external_ids",
    "known_names",
    "first_year",
    "visibility_groups",
  ],
  properties: {
    id: {
      type: "string",
      format: "UUID",
    },
    hidden: {
      type: "boolean",
    },
    external_ids: {
      type: "array",
      items: {
        type: "string",
      },
    },
    known_names: {
      type: "array",
      items: {
        type: "string",
      },
    },
    sport: {
      type: "string",
      enum: ["baseball", "softball"],
    },
    league: {
      type: "string",
    },
    first_year: {
      type: "string",
    },
    birthdate: {
      type: "string",
      format: "date",
    },
    pitch_side: {
      type: "string",
    },
    hit_side: {
      type: "string",
    },
    visibility_groups: {
      type: "array",
      items: {
        type: "string",
      },
    },
    management_groups: {
      type: "array",
      items: {
        type: "string",
      },
    },
    team_history: {
      type: "array",
      items: {
        type: "object",
        required: ["team_id", "start_time", "end_time"],
        properties: {
          team_id: {
            type: "string",
          },
          team_name: {
            type: "string",
          },
          start_time: {
            type: "string",
            format: "date",
          },
          end_time: {
            type: "string",
            format: "date",
          },
        },
      },
    },
  },
} as const;

export const LineupEntrySchema = {
  type: "object",
  properties: {
    externalId: {
      type: "string",
      default: null,
      nullable: true,
    },
    hitSide: {
      $ref: "#/components/schemas/SideType",
      default: null,
      nullable: true,
    },
    pitchSide: {
      $ref: "#/components/schemas/SideType",
      default: null,
      nullable: true,
    },
    playerName: {
      type: "string",
      default: null,
      nullable: true,
    },
    jerseyNumber: {
      type: "number",
      default: null,
      nullable: true,
    },
    position: {
      oneOf: [
        {
          type: "integer",
        },
        {
          $ref: "#/components/schemas/LineupPositions",
        },
      ],
    },
  },
  required: ["position"],
} as const;

export const LineupPairSchema = {
  type: "object",
  properties: {
    awayLineup: {
      type: "array",
      items: {
        $ref: "#/components/schemas/LineupEntry",
      },
    },
    homeLineup: {
      type: "array",
      items: {
        $ref: "#/components/schemas/LineupEntry",
      },
    },
  },
  required: ["home_lineup", "away_lineup"],
} as const;

export const LineupPositionsSchema = {
  type: "string",
  enum: ["pitcher", "catcher"],
} as const;

export const OrganizationSchema = {
  properties: {
    city: {
      type: "string",
      default: null,
      nullable: true,
    },
    competitionLevel: {
      $ref: "#/components/schemas/CompetitionLevel",
      default: null,
      nullable: true,
    },
    id: {
      type: "string",
      default: null,
      nullable: true,
    },
    orgName: {
      type: "string",
    },
    sport: {
      $ref: "#/components/schemas/SportType",
      default: null,
      nullable: true,
    },
    state: {
      type: "string",
      default: null,
      nullable: true,
    },
    orgId: {
      type: "string",
    },
  },
  required: ["orgId", "orgName"],
  type: "object",
} as const;

export const RolesSchema = {
  type: "string",
  enum: [
    "magnus_admin",
    "magnus_super_admin",
    "aura_admin",
    "aura_super_admin",
    "report_upload",
    "report_download_raw",
    "device_data_download",
  ],
} as const;

export const OrgRolesSchema = {
  type: "string",
  enum: [
    "unverified_account_owner",
    "account_owner",
    "staff_admin",
    "staff",
    "tagger",
    "viewer",
  ],
} as const;

export const SideTypeSchema = {
  enum: ["left", "right", "switch"],
  type: "string",
} as const;

export const SportTypeSchema = {
  enum: ["baseball", "softball"],
  type: "string",
} as const;

export const GameTypeSchema = {
  enum: ["game", "bullpen", "batting_practice"],
  type: "string",
} as const;

export const SubstitutionSchema = {
  type: "object",
  properties: {
    new_lineup_player: {
      $ref: "#/components/schemas/LineupEntry",
    },
    previous_lineup_player: {
      $ref: "#/components/schemas/LineupEntry",
    },
    side: {
      $ref: "#/components/schemas/TeamSide",
    },
    sub_time: {
      format: "date-time",
      type: "string",
    },
  },
  required: ["sub_time", "side", "previous_lineup_player", "new_lineup_player"],
} as const;

export const TeamPairSchema = {
  type: "object",
  properties: {
    away: {
      type: "string",
    },
    home: {
      type: "string",
    },
  },
  required: ["home", "away"],
} as const;

export const TeamColorPairSchema = {
  type: "object",
  properties: {
    away: {
      type: "string",
      nullable: true,
      description: "Hex color value for away team (#RRGGBB or",
    },
    home: {
      type: "string",
      nullable: true,
      description: "Hex color value for home team (#RRGGBB or",
    },
  },
} as const;

export const TeamSideSchema = {
  enum: ["home", "away"],
  type: "string",
} as const;

export const CompetitionLevelSchema = {
  type: "string",
  enum: [
    "ncaa_d1",
    "ncaa_d2",
    "ncaa_d3",
    "naia",
    "juco",
    "high_school",
    "college_summer_team",
    "professional",
    "facility",
  ],
} as const;

export const UserUpdateRequestBodySchema = {
  additionalProperties: false,
  properties: {
    orgId: {
      type: "string",
    },
    givenName: {
      type: "string",
      default: null,
      nullable: true,
    },
    familyName: {
      type: "string",
      default: null,
      nullable: true,
    },
    orgRoles: {
      items: {
        $ref: "#/components/schemas/OrgRoles",
      },
      type: "array",
    },
  },
  required: ["orgRoles", "orgId"],
  type: "object",
} as const;

export const GameEndRequestBodySchema = {
  additionalProperties: false,
  properties: {
    endTime: {
      format: "date-time",
      type: "string",
      default: null,
      nullable: true,
    },
  },
  type: "object",
} as const;

export const GameTimeChangeRequestValidationSchema = {
  additionalProperties: false,
  properties: {
    times: {
      items: {
        $ref: "#/components/schemas/GamePart",
      },
      type: "array",
    },
  },
  type: "object",
} as const;

export const GameStartRequestBodySchema = {
  additionalProperties: false,
  properties: {
    awayTeamColor: {
      type: "string",
      nullable: true,
      description: "Hex color value for away team (#RRGGBB or",
    },
    awayTeamId: {
      type: "string",
    },
    awayTeamLineup: {
      items: {
        $ref: "#/components/schemas/LineupEntry",
      },
      type: "array",
    },
    homeTeamColor: {
      type: "string",
      nullable: true,
      description: "Hex color value for home team (#RRGGBB or",
    },
    homeTeamId: {
      type: "string",
    },
    homeTeamLineup: {
      items: {
        $ref: "#/components/schemas/LineupEntry",
      },
      type: "array",
    },
    machineUuid: {
      format: "uuid4",
      type: "string",
    },
    sport: {
      $ref: "#/components/schemas/SportType",
    },
    type: {
      $ref: "#/components/schemas/GameType",
      default: "game",
    },
  },
  required: ["machineUuid"],
  type: "object",
} as const;

export const GameSubstitutionRequestBodySchema = {
  additionalProperties: false,
  properties: {
    in: {
      $ref: "#/components/schemas/LineupEntry",
    },
    out: {
      $ref: "#/components/schemas/LineupEntry",
      nullable: true,
      default: null,
    },
    side: {
      $ref: "#/components/schemas/TeamSide",
    },
    time: {
      type: "string",
      format: "date-time",
      default: null,
      nullable: true,
    },
  },
  required: ["side", "in"],
  type: "object",
} as const;

export const GameTeamSwapRequestBodySchema = {
  type: "object",
  additionalProperties: false,
  required: ["machineUuid"],
  properties: {
    machineUuid: {
      type: "string",
      format: "uuid",
      description: "The machine whose active game is swapped or confirmed",
    },
    at: {
      type: "string",
      format: "date-time",
      description: `The time used to find the active game (and, on the smart routes, to check Smart Park access); defaults to now. A unix timestamp in seconds is also accepted.
`,
    },
  },
} as const;

export const GameTeamSwapResponseSchema = {
  type: "object",
  required: ["detail", "game"],
  properties: {
    detail: {
      type: "string",
    },
    game: {
      description: "The updated game, or null when no game is active",
      nullable: true,
      allOf: [
        {
          $ref: "#/components/schemas/Game",
        },
      ],
    },
  },
} as const;

export const GameActiveLineupsRequestBodySchema = {
  type: "object",
  required: ["lineups"],
  properties: {
    fieldUuid: {
      type: "string",
      description: `The machine whose active game is edited; required unless machineUuid is given as a query parameter
`,
    },
    lineups: {
      type: "object",
      description: "At least one of homeLineup or awayLineup is required",
      properties: {
        homeLineup: {
          type: "array",
          items: {
            $ref: "#/components/schemas/LineupEntry",
          },
        },
        awayLineup: {
          type: "array",
          items: {
            $ref: "#/components/schemas/LineupEntry",
          },
        },
      },
    },
  },
} as const;

export const OrganizationsAssociateMachinesRequestBodySchema = {
  additionalProperties: false,
  type: "object",
  properties: {
    machineIds: {
      type: "array",
      items: {
        type: "string",
      },
    },
    duration: {
      $ref: "#/components/schemas/DurationType",
    },
  },
  required: ["machineIds"],
} as const;

export const OrganizationsAssociateTeamsRequestBodySchema = {
  additionalProperties: false,
  type: "object",
  properties: {
    externalIds: {
      type: "array",
      items: {
        type: "string",
      },
    },
    duration: {
      $ref: "#/components/schemas/DurationType",
    },
  },
  required: ["externalIds"],
} as const;

export const SaveOrganizationRequestBodySchema = {
  additionalProperties: false,
  type: "object",
  properties: {
    name: {
      type: "string",
    },
    city: {
      type: "string",
      default: null,
      nullable: true,
    },
    state: {
      type: "string",
      default: null,
      nullable: true,
    },
    sport: {
      $ref: "#/components/schemas/SportType",
    },
    competitionLevel: {
      $ref: "#/components/schemas/CompetitionLevel",
    },
  },
  required: ["name", "sport", "competitionLevel"],
} as const;

export const CreateInvitationRequestBodySchema = {
  additionalProperties: false,
  properties: {
    duration: {
      $ref: "#/components/schemas/DurationType",
    },
    orgId: {
      type: "string",
    },
    roles: {
      items: {
        $ref: "#/components/schemas/OrgRoles",
      },
      type: "array",
      uniqueItems: true,
    },
    startTime: {
      anyOf: [
        {
          format: "date-time",
          type: "string",
        },
        {
          type: "integer",
        },
      ],
      nullable: true,
      default: null,
    },
  },
  required: ["orgId", "roles", "duration"],
  type: "object",
} as const;

export const FeaturePassTemplateSchema = {
  type: "object",
  properties: {
    duration: {
      $ref: "#/components/schemas/DurationType",
    },
    feature_details: {
      type: "object",
      nullable: true,
      default: null,
    },
    feature_type: {
      $ref: "#/components/schemas/FeatureType",
    },
    start_time: {
      format: "date-time",
      type: "string",
      nullable: true,
      default: null,
    },
  },
  required: ["feature_type", "duration"],
} as const;

export const FeatureTypeSchema = {
  type: "string",
  enum: [
    "video_annotation",
    "reports",
    "org_member",
    "tagger",
    "team_and_player_viewer",
  ],
} as const;

export const LiveDataPassGroupTemplateSchema = {
  type: "object",
  properties: {
    duration: {
      $ref: "#/components/schemas/DurationType",
      default: "day",
    },
    group_id: {
      type: "string",
    },
    type: {
      enum: ["live-data-access"],
      default: "live-data-access",
      type: "string",
    },
  },
  required: ["group_id"],
} as const;

export const TokenSchema = {
  type: "object",
  properties: {
    created_at: {
      type: "integer",
    },
    created_by: {
      type: "string",
    },
    details: {
      anyOf: [
        {
          $ref: "#/components/schemas/FeaturePassTemplate",
        },
        {
          $ref: "#/components/schemas/LiveDataPassGroupTemplate",
        },
      ],
    },
    id: {
      type: "string",
    },
    num_uses: {
      type: "integer",
    },
    token: {
      type: "string",
    },
    ttl: {
      type: "integer",
    },
    valid_until: {
      type: "integer",
    },
    year_month: {
      type: "string",
    },
  },
  required: [
    "year_month",
    "id",
    "token",
    "created_by",
    "created_at",
    "details",
    "valid_until",
    "num_uses",
    "ttl",
  ],
} as const;

export const InvitationSchema = {
  type: "object",
  properties: {
    organization: {
      type: "object",
      $ref: "#/components/schemas/Organization",
    },
    owner: {
      type: "object",
      $ref: "#/components/schemas/User",
    },
    created_by: {
      type: "object",
      $ref: "#/components/schemas/User",
    },
    created_at: {
      type: "number",
    },
    status: {
      type: "string",
      enum: ["user_claimed", "user_not_claimed", "token_expired"],
    },
    token: {
      type: "string",
    },
  },
} as const;

export const PlayerDetailResponseSchema = {
  type: "object",
  properties: {
    known_names: {
      type: "array",
      items: {
        type: "string",
      },
    },
    external_ids: {
      type: "array",
      items: {
        type: "string",
      },
    },
    birthdate: {
      type: "string",
      format: "date",
      nullable: true,
    },
    photo: {
      type: "string",
      nullable: true,
    },
    league: {
      type: "string",
      nullable: false,
    },
    throws: {
      type: "string",
      nullable: true,
    },
    bats: {
      type: "string",
      nullable: true,
    },
    current_team_id: {
      type: "string",
      nullable: true,
    },
    current_team_name: {
      type: "string",
      nullable: true,
    },
    state: {
      type: "string",
      nullable: true,
    },
    city: {
      type: "string",
      nullable: true,
    },
    positions: {
      type: "array",
      items: {
        type: "string",
      },
      default: [],
    },
    machines_played_at: {
      type: "array",
      items: {
        $ref: "#/components/schemas/MachineInfo",
      },
      default: [],
    },
  },
} as const;

export const MachineInfoSchema = {
  type: "object",
  properties: {
    machine_uuid: {
      type: "string",
      description: "The unique identifier of the machine",
    },
    name: {
      type: "string",
      description: "The name of the machine",
    },
    region: {
      type: "string",
      description: "The region of the machine",
      nullable: true,
    },
    sport: {
      type: "string",
      description: "The sport type of the machine",
      nullable: true,
    },
  },
  required: ["machine_uuid", "name"],
} as const;

export const PlayerPitcherSchema = {
  type: "object",
  required: ["game_uuid", "game_started_at", "game_last_updated_at"],
  properties: {
    game_uuid: {
      type: "string",
      description: "Unique identifier for the game",
    },
    game_started_at: {
      type: "string",
      format: "date-time",
      description: "Timestamp when the game started",
    },
    game_last_updated_at: {
      type: "string",
      format: "date-time",
      description: "Timestamp when the game was last updated",
    },
    max_fb_velocity: {
      type: "number",
      format: "float",
      description: "Maximum fastball velocity",
    },
    max_fb_ivb: {
      type: "number",
      format: "float",
      description: "Maximum fastball induced vertical break",
    },
    max_fb_spin_rate: {
      type: "number",
      format: "float",
      description: "Maximum fastball spin rate",
    },
    avg_fb_velocity: {
      type: "number",
      format: "float",
      description: "Average fastball velocity",
    },
    avg_fb_efficiency: {
      type: "number",
      format: "float",
      description: "Average fastball efficiency percentage",
    },
    rate_in_zone: {
      type: "number",
      format: "float",
      description: "Rate of pitches thrown in the strike zone",
    },
    avg_exit_velocity_against: {
      type: "number",
      format: "float",
      description: "Average exit velocity of balls hit against this pitcher",
    },
    rate_k: {
      type: "number",
      format: "float",
      description: "Strike rate (strikeout rate)",
    },
    rate_walk: {
      type: "number",
      format: "float",
      description: "Walk rate",
    },
    rate_whiff: {
      type: "number",
      format: "float",
      description: "Whiff rate (swing and miss rate)",
    },
  },
} as const;

export const PlayerHitterSchema = {
  type: "object",
  required: ["game_uuid", "game_started_at", "game_last_updated_at"],
  properties: {
    game_uuid: {
      type: "string",
      description: "Unique identifier for the game",
    },
    game_started_at: {
      type: "string",
      format: "date-time",
      description: "Timestamp when the game started",
    },
    game_last_updated_at: {
      type: "string",
      format: "date-time",
      description: "Timestamp when the game was last updated",
    },
    rate_chase: {
      type: "number",
      format: "float",
      description: "Rate of swinging at pitches outside the strike zone",
    },
    rate_contact: {
      type: "number",
      format: "float",
      description: "Rate of making contact when swinging",
    },
    avg_ev_vs_fb: {
      type: "number",
      format: "float",
      description: "Average exit velocity against fastballs",
    },
    avg_ev_vs_offspeed: {
      type: "number",
      format: "float",
      description: "Average exit velocity against off-speed pitches",
    },
    max_exit_velocity: {
      type: "number",
      format: "float",
      description: "Maximum exit velocity recorded",
    },
    avg_exit_velocity: {
      type: "number",
      format: "float",
      description: "Average exit velocity",
    },
    max_distance: {
      type: "number",
      format: "float",
      description: "Maximum distance of hit ball",
    },
    avg_distance: {
      type: "number",
      format: "float",
      description: "Average distance of hit balls",
    },
    avg_launch: {
      type: "number",
      format: "float",
      description: "Average launch angle",
    },
    avg_spin: {
      type: "number",
      format: "float",
      description: "Average spin rate of hit balls",
    },
  },
} as const;

export const PlayerStatsPitcherSchema = {
  type: "object",
  required: [
    "max_fb_velocity",
    "max_fb_ivb",
    "max_fb_spin_rate",
    "avg_fb_velocity",
    "avg_fb_efficiency",
    "rate_in_zone",
    "avg_exit_velocity_against",
    "rate_k",
    "rate_walk",
    "rate_whiff",
  ],
  properties: {
    max_fb_velocity: {
      type: "number",
      format: "float",
      description: "Maximum fastball velocity",
    },
    max_fb_ivb: {
      type: "number",
      format: "float",
      description: "Maximum fastball induced vertical break",
    },
    max_fb_spin_rate: {
      type: "number",
      format: "float",
      description: "Maximum fastball spin rate",
    },
    avg_fb_velocity: {
      type: "number",
      format: "float",
      description: "Average fastball velocity",
    },
    avg_fb_efficiency: {
      type: "number",
      format: "float",
      description: "Average fastball efficiency percentage",
    },
    rate_in_zone: {
      type: "number",
      format: "float",
      description: "Rate of pitches thrown in the strike zone",
    },
    avg_exit_velocity_against: {
      type: "number",
      format: "float",
      description: "Average exit velocity of balls hit against this pitcher",
    },
    rate_k: {
      type: "number",
      format: "float",
      description: "Strike rate (strikeout rate)",
    },
    rate_walk: {
      type: "number",
      format: "float",
      description: "Walk rate",
    },
    rate_whiff: {
      type: "number",
      format: "float",
      description: "Whiff rate (swing and miss rate)",
    },
  },
} as const;

export const PlayerStatsHitterSchema = {
  type: "object",
  required: [
    "rate_chase",
    "rate_contact",
    "avg_ev_vs_fb",
    "avg_ev_vs_offspeed",
    "max_exit_velocity",
    "avg_exit_velocity",
    "max_distance",
    "avg_distance",
    "avg_launch",
    "avg_spin",
  ],
  properties: {
    rate_chase: {
      type: "number",
      format: "float",
      description: "Rate of swinging at pitches outside the strike zone",
    },
    rate_contact: {
      type: "number",
      format: "float",
      description: "Rate of making contact when swinging",
    },
    avg_ev_vs_fb: {
      type: "number",
      format: "float",
      description: "Average exit velocity against fastballs",
    },
    avg_ev_vs_offspeed: {
      type: "number",
      format: "float",
      description: "Average exit velocity against off-speed pitches",
    },
    max_exit_velocity: {
      type: "number",
      format: "float",
      description: "Maximum exit velocity recorded",
    },
    avg_exit_velocity: {
      type: "number",
      format: "float",
      description: "Average exit velocity",
    },
    max_distance: {
      type: "number",
      format: "float",
      description: "Maximum distance of hit ball",
    },
    avg_distance: {
      type: "number",
      format: "float",
      description: "Average distance of hit balls",
    },
    avg_launch: {
      type: "number",
      format: "float",
      description: "Average launch angle",
    },
    avg_spin: {
      type: "number",
      format: "float",
      description: "Average spin rate of hit balls",
    },
  },
} as const;

export const TeamTrendsHitterStatsSchema = {
  type: "object",
  properties: {
    avg_exit_velocity: {
      type: "number",
      format: "float",
      nullable: true,
      description: "Average exit velocity",
    },
    hard_hit_rate: {
      type: "number",
      format: "float",
      nullable: true,
      description: "Hard hit rate",
    },
    avg_distance: {
      type: "number",
      format: "float",
      nullable: true,
      description: "Average distance",
    },
    whiff_rate: {
      type: "number",
      format: "float",
      nullable: true,
      description: "Whiff rate",
    },
    avg_ev_in_air: {
      type: "number",
      format: "float",
      nullable: true,
      description: "Average exit velocity in air",
    },
    avg_ev_on_gb: {
      type: "number",
      format: "float",
      nullable: true,
      description: "Average exit velocity on ground balls",
    },
    contact_rate: {
      type: "number",
      format: "float",
      nullable: true,
      description: "Contact rate",
    },
    chase_rate: {
      type: "number",
      format: "float",
      nullable: true,
      description: "Chase rate",
    },
    ground_ball_rate: {
      type: "number",
      format: "float",
      nullable: true,
      description: "Ground ball rate",
    },
    swstr_rate: {
      type: "number",
      format: "float",
      nullable: true,
      description: "Swinging strike rate",
    },
  },
} as const;

export const TeamTrendsPitcherStatsSchema = {
  type: "object",
  properties: {
    avg_ev_against: {
      type: "number",
      format: "float",
      nullable: true,
      description: "Average exit velocity against",
    },
    avg_ev_against_in_air: {
      type: "number",
      format: "float",
      nullable: true,
      description: "Average exit velocity against in air",
    },
    avg_ev_against_on_ground: {
      type: "number",
      format: "float",
      nullable: true,
      description: "Average exit velocity against on ground",
    },
    whiff_rate: {
      type: "number",
      format: "float",
      nullable: true,
      description: "Whiff rate",
    },
    fps_rate: {
      type: "number",
      format: "float",
      nullable: true,
      description: "First pitch strike rate",
    },
    fly_ball_rate: {
      type: "number",
      format: "float",
      nullable: true,
      description: "Fly ball rate",
    },
    ground_ball_rate: {
      type: "number",
      format: "float",
      nullable: true,
      description: "Ground ball rate",
    },
    chase_rate: {
      type: "number",
      format: "float",
      nullable: true,
      description: "Chase rate",
    },
    contact_rate: {
      type: "number",
      format: "float",
      nullable: true,
      description: "Contact rate",
    },
    swstr_rate: {
      type: "number",
      format: "float",
      nullable: true,
      description: "Swinging strike rate",
    },
  },
} as const;

export const TeamTrendsPitcherPracticeStatsSchema = {
  type: "object",
  properties: {
    avg_fb_velocity: {
      type: "number",
      format: "float",
      nullable: true,
      description: "Average fastball velocity",
    },
    avg_fb_strike_rate: {
      type: "number",
      format: "float",
      nullable: true,
      description: "Average fastball strike rate",
    },
    avg_fb_total_break: {
      type: "number",
      format: "float",
      nullable: true,
      description: "Average fastball total break",
    },
    avg_change_up_velocity: {
      type: "number",
      format: "float",
      nullable: true,
      description: "Average changeup velocity",
    },
    avg_fb_vs_ch_velocity: {
      type: "number",
      format: "float",
      nullable: true,
      description: "Average fastball vs changeup velocity difference",
    },
    avg_change_up_strike_rate: {
      type: "number",
      format: "float",
      nullable: true,
      description: "Average changeup strike rate",
    },
    avg_breaking_ball_velocity: {
      type: "number",
      format: "float",
      nullable: true,
      description: "Average breaking ball velocity",
    },
    avg_breaking_ball_total_break: {
      type: "number",
      format: "float",
      nullable: true,
      description: "Average breaking ball total break",
    },
    total_avg_strike_rate: {
      type: "number",
      format: "float",
      nullable: true,
      description: "Total average strike rate",
    },
  },
} as const;

export const ChartsDataSchema = {
  type: "object",
  properties: {
    machine_uuid: {
      type: "string",
      nullable: true,
    },
    game_uuid: {
      type: "string",
      nullable: true,
    },
    pitcher_team_uuid: {
      type: "string",
      nullable: true,
    },
    pitcher_internal_uuid: {
      type: "string",
      nullable: true,
    },
    pitcher_external_uuid: {
      type: "string",
      nullable: true,
    },
    hitter_team_uuid: {
      type: "string",
      nullable: true,
    },
    hitter_internal_uuid: {
      type: "string",
      nullable: true,
    },
    hitter_external_uuid: {
      type: "string",
      nullable: true,
    },
    home_team_uuid: {
      type: "string",
      nullable: true,
    },
    away_team_uuid: {
      type: "string",
      nullable: true,
    },
    sport: {
      type: "string",
      nullable: true,
    },
    game_type: {
      type: "string",
      nullable: true,
    },
    competition_level: {
      type: "string",
      nullable: true,
    },
    game_started_at: {
      type: "string",
      nullable: true,
    },
    game_last_updated_at: {
      type: "string",
      nullable: true,
    },
    pitch_type: {
      type: "string",
      nullable: true,
    },
    play_result: {
      type: "string",
      nullable: true,
    },
    pitcher_handedness: {
      type: "string",
      nullable: true,
    },
    hitter_handedness: {
      type: "string",
      nullable: true,
    },
    is_fastball: {
      type: "boolean",
      nullable: true,
    },
    is_offspeed: {
      type: "boolean",
      nullable: true,
    },
    is_contact: {
      type: "boolean",
      nullable: true,
    },
    is_whiff: {
      type: "boolean",
      nullable: true,
    },
    is_hit: {
      type: "boolean",
      nullable: true,
    },
    is_out: {
      type: "boolean",
      nullable: true,
    },
    points_spray_chart: {
      type: "array",
      items: {},
      nullable: true,
    },
    points_heatmap_location: {
      type: "array",
      items: {},
      nullable: true,
    },
    points_release: {
      type: "array",
      items: {},
      nullable: true,
    },
    points_tilt_and_spin: {
      type: "array",
      items: {},
      nullable: true,
    },
    points_break_and_movement: {
      type: "array",
      items: {},
      nullable: true,
    },
    points_launch: {
      type: "array",
      items: {},
      nullable: true,
    },
    points_contact: {
      type: "array",
      items: {},
      nullable: true,
    },
    avg_exit_velocity_per_zone_with_edges: {
      type: "object",
      additionalProperties: {
        type: "number",
        format: "float",
      },
      nullable: true,
    },
    max_exit_velocity_per_zone_with_edges: {
      type: "object",
      additionalProperties: {
        type: "number",
        format: "float",
      },
      nullable: true,
    },
    rate_contact_per_zone_with_edges: {
      type: "object",
      additionalProperties: {
        type: "number",
        format: "float",
      },
      nullable: true,
    },
    rate_whiff_per_zone_with_edges: {
      type: "object",
      additionalProperties: {
        type: "number",
        format: "float",
      },
      nullable: true,
    },
    rate_hit_per_zone_with_edges: {
      type: "object",
      additionalProperties: {
        type: "number",
        format: "float",
      },
      nullable: true,
    },
    count_per_zone_with_edges: {
      type: "object",
      additionalProperties: {
        type: "integer",
        format: "int32",
      },
      nullable: true,
    },
    count_in_zone: {
      type: "integer",
      format: "int32",
      nullable: true,
    },
    count_in_zone_with_edges: {
      type: "integer",
      format: "int32",
      nullable: true,
    },
  },
} as const;

export const TeamsTopPitcherStatsSchema = {
  type: "object",
  properties: {
    player_internal_uuid: {
      type: "string",
    },
    player_external_id: {
      type: "string",
    },
    player_name: {
      type: "string",
    },
    max_fb_velocity: {
      type: "number",
      format: "float",
      nullable: true,
    },
    max_fb_ivb: {
      type: "number",
      format: "float",
      nullable: true,
    },
    max_horz_break: {
      type: "number",
      format: "float",
      nullable: true,
    },
  },
  required: ["player_internal_uuid", "player_external_id", "player_name"],
} as const;

export const TeamsTopHitterStatsSchema = {
  type: "object",
  properties: {
    player_internal_uuid: {
      type: "string",
    },
    player_external_id: {
      type: "string",
    },
    player_name: {
      type: "string",
    },
    max_exit_velocity: {
      type: "number",
      format: "float",
      nullable: true,
    },
    max_distance: {
      type: "number",
      format: "float",
      nullable: true,
    },
    max_launch_angle: {
      type: "number",
      format: "float",
      nullable: true,
    },
  },
  required: ["player_internal_uuid", "player_external_id", "player_name"],
} as const;

export const LEDModesSchema = {
  type: "string",
  enum: ["umpire_assist", "stat_tracking", "blocked"],
} as const;

export const KnownScheduleSourcesSchema = {
  type: "string",
  enum: ["playbook365"],
} as const;

export const ScheduleInternalSchema = {
  type: "object",
  properties: {
    name: {
      type: "string",
      nullable: true,
    },
    notes: {
      type: "string",
      nullable: true,
      description: "Notes, max 1000 characters",
    },
    org_id: {
      type: "string",
      nullable: true,
      description:
        "Organization ID. Will be auto-prefixed with org_ if not already present.",
    },
    park: {
      nullable: true,
      allOf: [
        {
          $ref: "#/components/schemas/ParkConfig",
        },
      ],
    },
    game: {
      nullable: true,
      allOf: [
        {
          $ref: "#/components/schemas/Game",
        },
      ],
    },
    led: {
      nullable: true,
      allOf: [
        {
          $ref: "#/components/schemas/LEDModes",
        },
      ],
    },
    updated: {
      type: "number",
      format: "double",
      description: "Unix timestamp in seconds. Defaults to current time.",
    },
  },
} as const;

export const TeamPairFullSchema = {
  type: "object",
  properties: {
    home: {
      nullable: true,
      allOf: [
        {
          $ref: "#/components/schemas/TeamDB",
        },
      ],
    },
    away: {
      nullable: true,
      allOf: [
        {
          $ref: "#/components/schemas/TeamDB",
        },
      ],
    },
  },
} as const;

export const PlayerListsSideSchema = {
  type: "object",
  properties: {
    home: {
      nullable: true,
      type: "array",
      items: {
        $ref: "#/components/schemas/LineupEntry",
      },
    },
    away: {
      nullable: true,
      type: "array",
      items: {
        $ref: "#/components/schemas/LineupEntry",
      },
    },
  },
} as const;

export const ScheduleExternalSchema = {
  type: "object",
  required: ["id", "source"],
  additionalProperties: true,
  properties: {
    id: {
      type: "string",
    },
    source: {
      type: "string",
      description: 'Arbitrary string or a known source such as "playbook365".',
    },
    name: {
      type: "string",
      nullable: true,
    },
    notes: {
      type: "string",
      nullable: true,
      description: "Notes, max 1000 characters",
    },
    updated: {
      type: "number",
      format: "double",
      description: "Unix timestamp in seconds. Defaults to current time.",
    },
    game: {
      nullable: true,
      allOf: [
        {
          $ref: "#/components/schemas/Game",
        },
      ],
    },
    teams: {
      nullable: true,
      allOf: [
        {
          $ref: "#/components/schemas/TeamPairFull",
        },
      ],
    },
    players: {
      nullable: true,
      allOf: [
        {
          $ref: "#/components/schemas/PlayerListsSide",
        },
      ],
    },
    age_group: {
      nullable: true,
      allOf: [
        {
          $ref: "#/components/schemas/AgeGroup",
        },
      ],
    },
    sport: {
      nullable: true,
      allOf: [
        {
          $ref: "#/components/schemas/SportType",
        },
      ],
    },
  },
} as const;

export const ScheduleQueueSchema = {
  type: "object",
  required: ["machine_uuid", "year_month", "schedule_time_s"],
  properties: {
    id: {
      nullable: true,
      type: "string",
    },
    machine_uuid: {
      type: "string",
    },
    year_month: {
      type: "string",
    },
    schedule_time_s: {
      type: "integer",
    },
  },
} as const;

export const ScheduleMergedSchema = {
  type: "object",
  properties: {
    name: {
      type: "string",
      nullable: true,
    },
    park: {
      nullable: true,
      allOf: [
        {
          $ref: "#/components/schemas/ParkConfig",
        },
      ],
    },
    game: {
      nullable: true,
      allOf: [
        {
          $ref: "#/components/schemas/Game",
        },
      ],
    },
    teams: {
      nullable: true,
      allOf: [
        {
          $ref: "#/components/schemas/TeamPairFull",
        },
      ],
    },
    players: {
      nullable: true,
      allOf: [
        {
          $ref: "#/components/schemas/PlayerListsSide",
        },
      ],
    },
    led: {
      nullable: true,
      allOf: [
        {
          $ref: "#/components/schemas/LEDModes",
        },
      ],
    },
  },
} as const;

export const ScheduleSchema = {
  allOf: [
    {
      $ref: "#/components/schemas/ScheduleQueue",
    },
    {
      type: "object",
      properties: {
        internal: {
          nullable: true,
          allOf: [
            {
              $ref: "#/components/schemas/ScheduleInternal",
            },
          ],
        },
        external: {
          nullable: true,
          allOf: [
            {
              $ref: "#/components/schemas/ScheduleExternal",
            },
          ],
        },
        merged: {
          nullable: true,
          allOf: [
            {
              $ref: "#/components/schemas/ScheduleMerged",
            },
          ],
        },
      },
    },
  ],
} as const;
